import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Header from './pages/Header';
import Footer from './pages/Footer';
import AgeCalculator from './pages/AgeCalculator';
import WordCounter from './pages/WordCounter';
import BmiCalculator from './pages/BmiCalculator';
import QrGenerator from './pages/QrGenerator';
import CaseConverter from './pages/CaseConverter';
import PasswordGenerator from './pages/PasswordGenerator';
import JsonFormatter from './pages/JsonFormatter';
import LoremIpsumGenerator from './pages/LoremIpsumGenerator';
import ColorPicker from './pages/ColorPicker';
import ThumbnailDownloader from './pages/ThumbnailDownloader';
import ImageToBase64 from './pages/ImageToBase64';
import MetaTagGenerator from './pages/MetaTagGenerator';
import YouTubeInfoExtractor from './pages/YouTubeInfoExtractor';
import WebsiteScreenshot from './pages/WebsiteScreenshot';
import StopwatchTimer from "./pages/StopwatchTimer";
import CountdownTimer from './pages/CountdownTimer';
import KeywordSearchVolume from './pages/KeywordSearchVolume';
import ScrollToTop from "./components/ScrollToTop";
import HtmlFormatter from "./pages/HtmlFormatter";
import CssFormatter from './pages/CssFormatter';
import JsMinifierFormatter from './pages/JavascriptFormatter';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AboutUs from './pages/AboutUs'; 
import Disclaimer from './pages/Disclaimer'; 
import ContactUs from './pages/ContactUs'; 
import CssFilterGenerator from './pages/CssFilterGenerator';
import GradientGenerator from './pages/GradientGenerator';
import ImageFilterGenerator from "./pages/ImageFilterGenerator";
import CalorieCalculator from "./pages/CalorieCalculator";


const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <section className="sec-i">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/age-calculator" element={<AgeCalculator />} />
          <Route path="/word-counter" element={<WordCounter />} />
          <Route path="/bmi-calculator" element={<BmiCalculator />} />
          <Route path="/qr-code-generator" element={<QrGenerator />} />
          <Route path="/text-case-converter" element={<CaseConverter />} />
          <Route path="/password-generator" element={<PasswordGenerator />} />
          <Route path="/json-formatter" element={<JsonFormatter />} />
          <Route path="/lorem-ipsum-generator" element={<LoremIpsumGenerator />} />
          <Route path="/color-picker" element={<ColorPicker />} />
          <Route path="/youtube-thumbnail-downloader" element={<ThumbnailDownloader />} />
          <Route path="/image-to-base64" element={<ImageToBase64 />} />
          <Route path="/meta-tag-generator" element={<MetaTagGenerator />} />
          <Route path="/youtube-info-extractor" element={<YouTubeInfoExtractor />} />
          <Route path="/website-screenshot-generator" element={<WebsiteScreenshot />} />
          <Route path="/online-stopwatch-timer" element={<StopwatchTimer />} />
          <Route path="/countdown-timer" element={<CountdownTimer />} />
          <Route path="/keyword-search-volume" element={<KeywordSearchVolume />} />
          <Route path="/html-formatter" element={<HtmlFormatter />} />
          <Route path="/css-formatter" element={<CssFormatter />} />
          <Route path="/javascript-formatter" element={<JsMinifierFormatter />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/css-filter-generator" element={<CssFilterGenerator />} />
          <Route path="/gradient-generator" element={<GradientGenerator />} />
          <Route path="/image-filter-generator" element={<ImageFilterGenerator />} />
          <Route path="/calorie-calculator" element={<CalorieCalculator />} />


        </Routes>
      </section>
      <Footer />
    </Router>
  );
};

export default App;
